import { useState } from "react";
import { useChangePasswordMutation } from "../../../api/ProfileAPI";

interface ThisProps {
}

const AccountPasswordComponent: React.FC<ThisProps> = (props) => {

  const [changePasswordAPI] = useChangePasswordMutation();
  const [oldPassword, setOldPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [newPasswordRepeat, setNewPasswordRepeat] = useState<string>("");

  const handlePasswordChange = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    changePasswordAPI({ oldPassword: oldPassword, newPassword: newPassword, newPasswordRepeat: newPasswordRepeat })
      .unwrap()
      .then(() => {
        alert("Passwort geändert!");
      })
      .catch((error) => {
        alert("Fehler: " + error.data.text);
      });
  }

  return (
    <>

      <h4 style={{ marginTop: "50px" }}>Passwort ändern:</h4>

      <form className='form-group' style={{ marginTop: "30px", width: "40%" }}>
        <label>Bisheriges Passwort:</label>
        <input className='form-control' type="password" placeholder="Bisheriges Passwort" onChange={(e) => setOldPassword(e.target.value)} />
        <br />
        <label>Neues Passwort:</label>
        <input className='form-control' type="password" placeholder="Neues Passwort" onChange={(e) => setNewPassword(e.target.value)} />
        <br />
        <label>Neues Passwort wiederholen:</label>
        <input className='form-control' type="password" placeholder="Neues Passwort wiederholen" onChange={(e) => setNewPasswordRepeat(e.target.value)} />
        <br />
        <button className='btn btn-primary' type="submit" onClick={handlePasswordChange}>Passwort ändern</button>
      </form>

    </>
  );
}

export default AccountPasswordComponent;
